// extracted by mini-css-extract-plugin
module.exports = {"message":"_3Nr7iw","atfUnavailableBox":"EakWZ3","messageRedesign":"_2YYtnV"};